import React from 'react';
import { Route } from 'react-router-dom';

import HomePageLayout from './Layout/homePage';
import DefaultLayout from './Layout/default';

export function HomeRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <HomePageLayout>
          <Component {...props} />
        </HomePageLayout>
      )}
    />
  );
}

export default ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <DefaultLayout>
          <Component {...props} />
        </DefaultLayout>
      )}
    />
  );
};
